/* Ja-vie — cart stock limits.
   Caps the quantity stepper at available inventory and surfaces inline
   messaging. Inventory values are printed server-side by
   snippets/cart-item.liquid as data-jv-max, so no app or extra API call. */
(function () {
  'use strict';

  if (window.__jvCartStock) return;
  window.__jvCartStock = true;

  var SEL = '.js-qty__wrapper[data-jv-max]';

  function up(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function read(wrapper) {
    var input = wrapper.querySelector('.js-qty__num');
    var max = parseInt(wrapper.getAttribute('data-jv-max'), 10);
    var qty = parseInt(input ? input.value : '', 10);
    return {
      input: input,
      max: isNaN(max) ? null : max,
      qty: isNaN(qty) ? 0 : qty
    };
  }

  function sync(wrapper) {
    var s = read(wrapper);
    if (s.max === null || s.max <= 0) return;

    var atMax = s.qty >= s.max;
    wrapper.classList.toggle('jv-qty--at-max', atMax);

    var plus = wrapper.querySelector('.js-qty__adjust--plus');
    if (plus) {
      if (atMax) {
        plus.setAttribute('disabled', 'disabled');
        plus.setAttribute('aria-disabled', 'true');
      } else {
        plus.removeAttribute('disabled');
        plus.removeAttribute('aria-disabled');
      }
    }

    var item = up(wrapper, '.cart__item');
    var note = item ? item.querySelector('.jv-stock-note--max') : null;
    if (note) note.hidden = !atMax;

    var low = item ? item.querySelector('.jv-stock-note--low') : null;
    if (low) low.hidden = atMax;
  }

  function syncAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) sync(nodes[i]);
  }

  function nudge(wrapper) {
    wrapper.classList.remove('jv-qty--nudge');
    void wrapper.offsetWidth;
    wrapper.classList.add('jv-qty--nudge');
  }

  /* Capture phase so the theme's own stepper handler never runs past max. */
  document.addEventListener(
    'click',
    function (e) {
      var plus = up(e.target, '.js-qty__adjust--plus');
      if (!plus) return;
      var wrapper = up(plus, SEL);
      if (!wrapper) return;

      var s = read(wrapper);
      if (s.max === null || s.max <= 0) return;

      if (s.qty >= s.max) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge(wrapper);
        sync(wrapper);
      }
    },
    true
  );

  /* Typed input: clamp to available stock. */
  function onEdit(e) {
    var wrapper = up(e.target, SEL);
    if (!wrapper) return;
    var s = read(wrapper);
    if (s.max === null || s.max <= 0 || !s.input) return;
    if (s.qty > s.max) s.input.value = s.max;
    sync(wrapper);
  }

  document.addEventListener('input', onEdit, true);
  document.addEventListener('change', onEdit, true);

  function boot() {
    syncAll();

    /* The ajax cart replaces [data-products] wholesale on every update. */
    if (!window.MutationObserver) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncAll();
      });
    });
    var targets = document.querySelectorAll('[data-products]');
    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
